module.exports = __webpack_public_path__ + "img/ttxt.8be3fd16.png";